import { useEffect, useState } from 'react';
import { useAuth } from '../auth/use-auth';
import { CoreContextModel } from './core.context';
import { UserInfoDataProvider } from '../../domain/static-content/static-content.static-generation.model';

interface UseCoreContextProps {
  requiresAuthentication: boolean;
  displayLoggedInUser: boolean;
  userInfoDataProvider: UserInfoDataProvider;
  onPostLogin?: () => void;
}

export function useInitCore({ requiresAuthentication, displayLoggedInUser, userInfoDataProvider, onPostLogin }: UseCoreContextProps) {
  const { isAuthenticated, userInfo, onLogout, error } = useAuth({
    requiresAuthentication,
    displayLoggedInUser,
    userInfoDataProvider,
    onPostLogin,
  });

  const getAnonymousUserId = () => {
    return userInfo?.anonymousId || 'anonymous';
  };

  const coreContextState: CoreContextModel = {
    auth: {
      onLogout,
      getAnonymousUserId,
    },
  };

  const [coreContext, setCoreContext] = useState(coreContextState);

  useEffect(() => {
    setCoreContext({
      ...coreContext,
      auth: {
        ...coreContext.auth,
        error,
        isAuthenticated,
        user: userInfo,
        getAnonymousUserId,
      },
    });
  }, [isAuthenticated, userInfo, error]);

  return coreContext;
}
